var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"grouped-list__item",class:{'grouped-list__item_active': _vm.active, 'grouped-list__item_multiple': _vm.multiple },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }